import {
  CareerSiteFiltersOption,
  CareerSiteSettings,
} from 'api-clients/monolith';
import React, { useRef } from 'react';

import { ChatWidget } from '../chat-widget';
import { Banner } from './banner';
import { HomeBanner } from './home-banner';
import { HomeMain } from './home-main';
import { HomeSearch } from './home-search';

interface HomeProps {
  bannerUrl: string | null;
  brandSetting: CareerSiteSettings;
  radiusOptions: Array<CareerSiteFiltersOption>;
  filterOptions?: {
    category: Array<CareerSiteFiltersOption>;
    position: Array<CareerSiteFiltersOption>;
    locationName: Array<CareerSiteFiltersOption>;
    jobTypes: Array<CareerSiteFiltersOption>;
    jobHours: Array<CareerSiteFiltersOption>;
    countries: Array<CareerSiteFiltersOption>;
    states: Array<CareerSiteFiltersOption>;
    cities: Array<CareerSiteFiltersOption>;
  };
}

export function Home({
  bannerUrl,
  brandSetting,
  radiusOptions,
  filterOptions,
}: HomeProps) {
  const targetRef = useRef<HTMLDivElement>(null);

  const MENUBAR_HEIGHT = 64;

  const scrollToJobs = () => {
    if (targetRef.current) {
      const targetPosition = targetRef.current.offsetTop;
      window.scrollTo({
        top: targetPosition - MENUBAR_HEIGHT,
        behavior: 'smooth',
      });
    }
  };

  return (
    <div className="flex flex-col">
      {bannerUrl && <Banner bannerUrl={bannerUrl} />}
      <div className="w-full">
        {!bannerUrl && <HomeBanner showBackground />}
        <HomeSearch scrollToJobs={scrollToJobs} radiusOptions={radiusOptions} />
        <ChatWidget brandSetting={brandSetting} />
      </div>
      <div ref={targetRef} data-testid="jobs-scroll-target" />
      <div className="container flex flex-col gap-6 pb-20 pt-10">
        <HomeMain brandSetting={brandSetting} filterOptions={filterOptions} />
      </div>
    </div>
  );
}

Home.Skeleton = function HomeSkeleton() {
  return (
    <div className="flex flex-col">
      <div className="w-full">
        <HomeBanner.Skeleton />
        <div className="mx-auto h-[40px] w-[70%] rounded-[40px] bg-gray-100 lg:w-[50%]" />
        <HomeSearch.Skeleton />
      </div>
      <div className="container flex flex-col gap-6 pb-20 pt-10">
        <HomeMain.Skeleton />
      </div>
    </div>
  );
};
